// extracted by mini-css-extract-plugin
module.exports = {"description":"ForgotPasswordModal_description__3lVsV","button":"ForgotPasswordModal_button__hHqZJ"};